<aside
  class="flex h-full min-h-0 flex-col overflow-y-auto bg-linear-to-br from-brand-studio-dark to-brand-studio px-10 py-10 text-white">
  <div class="my-auto flex min-h-full flex-col justify-center gap-10">
  <p class="m-0 text-sm font-bold uppercase tracking-widest">{{ label() }}</p>
  @if (claimPitch()) {
  <div class="flex max-w-md flex-col gap-6">
    <h2 class="use-grotesque m-0 text-4xl font-bold leading-none text-balance">{{ onboarding.brandName() }} is ready to
      claim</h2>
    <ul class="m-0 flex list-none flex-col gap-4 p-0 text-lg font-semibold">
      <li>Creators matched to {{ onboarding.brandName() }}.</li>
      <li>Campaigns and your wallet use {{ onboarding.activeCurrency() }}.</li>
      <li>{{ trialLine() }}</li>
    </ul>
    <p class="m-0 text-xl font-bold">Claim the workspace on the left to continue.</p>
  </div>
  } @else {
  <article class="max-w-md overflow-hidden rounded-xl bg-card text-foreground shadow-xl">
    @if (filled() && onboarding.draft().brand?.bannerUrl) {
      <img [src]="onboarding.draft().brand?.bannerUrl" alt="" class="h-16 w-full object-cover lg:h-24" />
    } @else {
      <div class="h-16 bg-linear-to-br from-brand-deep-purple to-primary lg:h-24"></div>
    }
    <div class="flex flex-col gap-4 px-6 pb-6">
      <div class="flex items-center gap-3 pt-5">
        @if (filled()) {
          <div class="flex shrink-0 items-center justify-center overflow-hidden rounded-lg border-4 border-card bg-linear-to-br from-brand-studio-dark to-brand-studio text-xl font-black text-white shadow-sm">
            @if (onboarding.draft().brand?.logoUrl) {
              <img [src]="onboarding.draft().brand?.logoUrl" alt="" class="size-14 rounded-lg object-contain" />
            } @else {
              <div class="flex size-14 items-center justify-center rounded-lg text-xl font-black text-white">
                {{ initial() }}
              </div>
            }
          </div>
          <div class="min-w-0 flex-1">
            <p class="m-0 text-2xl font-semibold text-foreground">{{ onboarding.brandName() }}</p>
            <p class="m-0 text-base text-muted-foreground">{{ onboarding.draft().brand?.domain }}</p>
          </div>
        } @else {
          <div class="size-14 shrink-0 rounded-lg bg-muted"></div>
          <div class="min-w-0 flex-1">
            <div class="mb-2 h-3.5 w-3/5 rounded bg-muted"></div>
            <div class="h-2.5 w-2/5 rounded bg-muted"></div>
          </div>
        }
      </div>

      @if (filled()) {
        <div class="flex flex-wrap gap-2">
          @if (onboarding.draft().brand?.industry) {
            <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{ onboarding.draft().brand?.industry }}</p>
          }
          <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{ onboarding.activeCurrency() }}</p>
          @if (onboarding.draft().brand?.socials?.length) {
            <p class="m-0 rounded-full bg-primary/10 px-3 py-1 text-sm font-bold text-accent">{{ onboarding.draft().brand?.socials?.length }} social channels</p>
          }
        </div>
      } @else {
        <div class="flex flex-col gap-2">
          <div class="h-2.5 w-full rounded bg-muted"></div>
          <div class="h-2.5 w-4/5 rounded bg-muted"></div>
        </div>
        <p class="m-0 text-base font-medium text-muted-foreground">Enter your website to see your workspace.</p>
      }

      <div class="flex items-center justify-between border-t border-border pt-3">
        <p class="m-0 text-base font-bold">{{ ownerLabel() }}</p>
        <p class="m-0 rounded-full px-3 py-1 text-sm font-bold"
          [class]="status().live ? 'bg-emerald-50 text-emerald-800 dark:bg-emerald-950/40 dark:text-emerald-200' : 'bg-primary/10 text-accent'">
          {{ status().label }}
        </p>
      </div>
    </div>
  </article>
  }
  <div>
    <p class="m-0 text-base font-semibold">Trusted by the world's most innovative teams</p>
    <!-- <p class="m-0 mt-3 text-2xl font-black">Adobe · BYD · GOLIN · Pizza Hut · monday.com</p> -->
    <div class="mt-6 flex flex-wrap items-center justify-between gap-x-6 gap-y-4">
      <img src="../../../../../assets/logos/cloud/adobe_dark.svg" alt="Adobe"
        class="h-8 w-auto brightness-0 invert xl:h-10 2xl:h-12" />
      <img src="../../../../../assets/logos/cloud/byd_dark.svg" alt="BYD"
        class="h-4 w-auto brightness-0 invert xl:h-5 2xl:h-6" />
      <img src="../../../../../assets/logos/cloud/golin_dark.svg" alt="GOLIN"
        class="h-5 w-auto brightness-0 invert xl:h-7 2xl:h-8" />
      <img src="../../../../../assets/logos/cloud/pizzahut_dark.svg" alt="Pizza Hut"
        class="h-5 w-auto brightness-0 invert xl:h-6 2xl:h-7" />
      <img src="../../../../../assets/logos/cloud/monday_dark.svg" alt="monday.com"
        class="h-4 w-auto brightness-0 invert xl:h-5 2xl:h-6" />
    </div>
  </div>
  </div>
</aside>